import { Component, Input, OnInit } from '@angular/core';
import { SelectItem } from 'primeng';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseTechnicalSectionComponent } from 'src/app/+grid-application-shared/components/common/base-technical-section.component';
import { CurrentTransformer } from 'src/app/+regep/entities/current-transformer';
import { RegepProcessStatus } from 'src/app/+regep/entities/enums/regepProcessStatus';
import { ProvisioningOfCurrentTransformers } from 'src/app/+regep/entities/provisioning-of-current-transformers';
import { RegistrationOfEnergyProducerTechnicalData } from 'src/app/+regep/entities/regep-technical-data';
import { RegepCommentsService } from 'src/app/+regep/services/regep-comments.service';
import { RegepOrderProcessService } from 'src/app/+regep/services/regep-order-process.service';
import { FormatterData } from 'src/app/constants/app.constants';
import { EnvironmentService } from 'src/app/services/environment.service';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-provisioning-of-current-transformers',
  templateUrl: './provisioning-of-current-transformers.component.html',
  styleUrls: ['./provisioning-of-current-transformers.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class ProvisioningOfCurrentTransformersComponent extends BaseTechnicalSectionComponent implements OnInit {
  @Input() technicalData: RegistrationOfEnergyProducerTechnicalData;

  canModeratorEdit: boolean;

  public readonly dateFormat = FormatterData.date;
  public readonly minDate = new Date();

  public readonly operators = {
    lsw: 'LSW',
    other: 'other',
  };

  transformerSizes: SelectItem[] = [
    '30 mm - 150/5 A',
    '30 mm - 250/5 A',
    '30 mm - 500/5 A',
    '60 mm - 250/5 A',
    '60 mm - 500/5 A',
    '60 mm - 1500/5 A',
    '80 mm - 600/5 A',
    '80 mm - 1500/5 A',
    '100 mm - 600/5 A',
    '100 mm - 1600/5 A',
    '100 mm - 2000/5 A',
    '120 mm - 1000/5 A',
    '120 mm - 1500/5 A',
    '120 mm - 2000/5 A',
    '20000/100 V',
  ].map(size => ({ label: size, value: size }));

  constructor(
    commentService: RegepCommentsService,
    environmentService: EnvironmentService,
    private readonly orderProcessService: RegepOrderProcessService
  ) {
    super(commentService, environmentService);
  }

  ngOnInit(): void {
    this.preventLeak(this.getCanModeratorEdit()).subscribe(canEdit => (this.canModeratorEdit = canEdit));
  }

  private getCanModeratorEdit(): Observable<boolean> {
    if (!this.isModeratorRole()) {
      return of(false);
    }

    return this.orderProcessService.orderProcess$.pipe(map(orderProcess => this.isInEditableStatus(orderProcess.status)));
  }

  private isInEditableStatus(status: RegepProcessStatus): boolean {
    return status < RegepProcessStatus.EngineeringOk;
  }

  get model(): ProvisioningOfCurrentTransformers {
    return this.technicalData.provisioning_of_current_transformers;
  }

  addTransformer() {
    this.model.current_transformers.push(new CurrentTransformer());
  }

  removeTransformer(index: number) {
    this.model.current_transformers.splice(index, 1);
  }

  hasTechnicalReasonsChange(value: boolean) {
    if (value) {
      return;
    }

    this.model.operator = null;
    this.model.current_transformers = [];
    this.model.preferred_date_for_pickup = null;
  }

  operatorChange(operator: string) {
    if (operator === this.operators.lsw) {
      this.model.current_transformers = [new CurrentTransformer()];
    } else {
      this.model.current_transformers = null;
    }
  }

  protected get sectionComment(): string | null {
    return this.technicalData.technical_specifications_sections_state?.provisioning_of_current_transformers_comment;
  }

  protected set sectionComment(value: string | null) {
    this.technicalData.technical_specifications_sections_state.provisioning_of_current_transformers_comment = value;
  }

  protected get sectionLocked(): boolean | null {
    return this.technicalData.technical_specifications_sections_state?.is_provisioning_of_current_transformers_locked;
  }

  protected set sectionLocked(value: boolean | null) {
    this.technicalData.technical_specifications_sections_state.is_provisioning_of_current_transformers_locked = value;
  }
}
